import { PointCloudHelpModalComponent } from '../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/point-cloud-help-modal.component';
import { PointCloudOutput } from '../../team-apis/otterdam/outputs/point-cloud-output';
import { OutputHelper } from './output-helper';

export class PointCloudOutputHelper extends OutputHelper<PointCloudOutput> {
  override isMultiFrameOutput = true;

  override getHelpModalType(_output: PointCloudOutput) {
    return PointCloudHelpModalComponent;
  }
}
